import { ResponseShopFeeds } from '@ads/front-core/api'

export const getDefaultFeedId = (feeds: ResponseShopFeeds): number => {
  if (!feeds?.length) {
    return null
  }
  const masterFeed = feeds.find(feed => feed.type === 'MASTER')
  if (masterFeed?.id) {
    return masterFeed.id
  }
  const readyFeed = feeds.find(feed => feed.status === 'READY')
  return readyFeed?.id ? readyFeed.id : feeds[0]?.id
}
